import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { copyFindExcursionsStore } from 'entities/excursions/models/copy-find-excursions/copy-find-excursions-store'

import { dateFormat } from 'shared/lib/dateFormat'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ButtonIconText } from 'shared/ui/button-icon-text'
import { Button } from 'shared/ui/button/button'

import s from './styles.module.scss'

interface Props {
  isSearch?: boolean
  type?: 'white' | 'grey'
  onSearch?: () => void
}

export const CopyFindForm: FC<Props> = observer(({ type, onSearch }) => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  const onClickDate = () => {
    navigate({
      pathname: RoutingPaths.excursion.calendar.path(),
      search: 'isSearch=true',
    })
  }

  const onClickTo = () => {
    navigate({
      pathname: RoutingPaths.excursion.searchDirection.path(),
      search: 'isSearch=true',
    })
  }

  const { departure_date, direction, name } =
    copyFindExcursionsStore.findExcursions

  const resultDate = dateFormat(departure_date || '')

  const buttonActive = departure_date && (direction || name)

  return (
    <div>
      <div className={s.block}>
        <ButtonIconText
          type={type}
          onClick={onClickTo}
          placeholder={t('to')}
          value={name || direction}
        />
      </div>
      <div className={s.block}>
        <ButtonIconText
          type={type}
          value={resultDate}
          onClick={onClickDate}
          placeholder={t('when')}
          rightIcon={AllIcons.CALENDAR}
        />
      </div>
      <Button
        onClick={() => {
          buttonActive && onSearch?.()
        }}
      >
        <p className={s.text}>{t('search')}</p>
      </Button>
    </div>
  )
})
